import React from 'react';
import PropTypes from 'prop-types';
import Question from '../../common/Question';
import TextAreaInput from '../../common/TextAreaInput';
import DocumentUpload from '../../DocumentUpload';
import './SummaryTab.scss';

function SummaryTab({
  proposal, onFormChange, errors, bio, showResumeQuestion,
  viewResumeUrl, uploadResumeUrl, userId, csrfToken, resume,
}) {
  return (
    <div className="responsibilities-tab">
      <div className="mb-4 summary">
        <Question
          title="1. Provide a brief summary of your experience related to this project."
          location="proposal-edit"
        >
          <div className="mt-4 ms-4 summary-input-container">
            <TextAreaInput
              formKey="about_consultant"
              onAnswerChange={(val) => onFormChange('about_consultant', val)}
              errors={errors}
              textAreaPrompt="We&apos;ve fetched this content from your bio.
            Please edit to make it relevant to this project."
              textPromptClass={!proposal.about_consultant && 'with-error-text'}
              placeholder={null}
              value={proposal.about_consultant || bio}
            />
          </div>
        </Question>
      </div>
      {showResumeQuestion
    && (
    <div className="resume-section mb-4">
      <div className="body-class-2 medium-weight mb-3">2. Resume</div>
      <div className="ms-4">
        <DocumentUpload
          buttonStyle="button"
          prompt="Upload Resume"
          viewDocumentUrl={viewResumeUrl}
          uploadDocumentUrl={uploadResumeUrl}
          userId={userId}
          documentType="resume"
          location="proposal-edit"
          csrfToken={csrfToken}
          document={resume}
          proposalResourceId={proposal.resource_id}
          saveOnUpload
        />
      </div>
    </div>
    )}
    </div>
  );
}

SummaryTab.propTypes = {
  proposal: PropTypes.shape({}).isRequired,
  onFormChange: PropTypes.func.isRequired,
  errors: PropTypes.shape({}).isRequired,
  showResumeQuestion: PropTypes.bool.isRequired,
  bio: PropTypes.string.isRequired,
  viewResumeUrl: PropTypes.string.isRequired,
  uploadResumeUrl: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  resume: PropTypes.shape({}).isRequired,
};

export default SummaryTab;
